export default __webpack_public_path__ + "static/media/ISSO CLASS-5 EXAM PATTERN 2026-27.5344f220.pdf";